import styled from 'styled-components'

import { mediaDesktopAndUp } from 'uiComponents/constants/customMedia'

import EditorialHeadline, { TextContainer } from './EditorialHeadline'

export default styled(EditorialHeadline)`
  align-items: flex-start;
  padding-left: 50px;
  word-break: break-word;

  @media ${mediaDesktopAndUp} {
    ${TextContainer} {
      max-width: 80%;
      text-align: left;
    }
  }
`
